import React, { Component } from 'react';
import { Form, Select } from 'antd';
import { injectIntl } from 'react-intl';
import PrintersSelectTable from './PrintersSelectTable'
import UsersSelectTable from './UsersSelectTable'
import UserGroupsSelectTable from './UserGroupsSelectTable'
import ReportDescription from './ReportDescription'
import {getReportParam, getDescriptionFromUrl} from '../utils/EmailReportsHelper'
import {REPORT_URL} from '../utils/constants'

const layout = {
    labelCol: {
        offset: 0,
        span: 3,
    },
/*    
    wrapperCol: {       
        offset: 0,
        span: 6,
    },
*/    
  };
  
const summary_report_type_name = "Report.Summary";
const detailed_report_type_name = "Report.Detailed";
const printer_id_name = "printer_id";
const user_id_name = "user_id";
const group_id_name = "group_id";

class CommonReportStep2 extends Component {

    constructor(props) {
        super(props);

        this.report_type_name = this.props.type === "summary" ? summary_report_type_name : detailed_report_type_name;

        if (this.props.type === "summary")
        {
            this.report_description = "Report.Summary.Description";
            this.report_types = [
                {key: "/printers", description: this.props.intl.formatMessage({id: "Printers"})},
                {key: "/users", description: this.props.intl.formatMessage({id: "Users"})},
                {key: "/groups", description: this.props.intl.formatMessage({id: "Groups"})}
            ];
        }
        else
        {
            this.report_description = "Report.Detailed.Description";
            this.report_types = [
                {key: "/printer", description: this.props.intl.formatMessage({id: "Printer"})},
                {key: "/user", description: this.props.intl.formatMessage({id: "User"})},
                {key: "/group", description: this.props.intl.formatMessage({id: "Group"})}
            ];
        }

        this.report_url = this.getReportUrl();

        this.printer_id = this.getPrinterId();
        if (this.printer_id !== undefined)
        {
            this.savePrinterId(this.printer_id);
        }

        this.user_id = this.getUserId();
        if (this.user_id !== undefined)
        {
            this.saveUserId(this.user_id);
        }

        this.group_id = this.getGroupId();
        if (this.group_id !== undefined)
        {
            this.saveGroupId(this.group_id);
        }


        this.props.callbacks.setStoreValue(this.report_type_name, REPORT_URL, this.report_url);
    }

    getReportUrl()
    {
        var report_url = this.props.type === "summary" ? "/printers" : "/printer";

        var stored_url = this.props.callbacks.getStoreValue(this.report_type_name, REPORT_URL);
        if (stored_url !== undefined)
        {
            report_url = stored_url;
        }
        else if (this.props.report.url !== undefined)
        {
            report_url = this.props.report.url;

            var index = report_url.indexOf('?');
            if ( index !== -1)
            {
              report_url = report_url.substring(0 , index);
            }
        }

        return report_url;
    }

    savePrinterId(printer_id)
    {
        this.props.callbacks.setStoreValue(this.report_type_name, printer_id_name, printer_id);
    }

    getPrinterId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, this.report_type_name, printer_id_name, this.props.report.url);
    }

    saveUserId(user_id)
    {
        this.props.callbacks.setStoreValue(this.report_type_name, user_id_name, user_id);
    }

    getUserId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, this.report_type_name, user_id_name, this.props.report.url);
    }

    saveGroupId(group_id)
    {
        this.props.callbacks.setStoreValue(this.report_type_name, group_id_name, group_id);
    }

    getGroupId()
    {
        return getReportParam(this.props.callbacks.getStoreValue, this.report_type_name, group_id_name, this.props.report.url);
    }

    onSelectChangePrinter(selectedRowKeys) {
        this.printer_id = selectedRowKeys[0];
        this.savePrinterId(this.printer_id);
    }

    onSelectChangeUser(selectedRowKeys) {
        this.user_id = selectedRowKeys[0];
        this.saveUserId(this.user_id);
    }

    onSelectChangeUserGroup(selectedRowKeys) {
        this.group_id = selectedRowKeys[0];
        this.saveGroupId(this.group_id);
    }

    onOnTypeChange(e, option)
    {
        this.report_url = option.key;
        this.props.callbacks.setStoreValue(this.report_type_name, REPORT_URL, this.report_url);
    }

    render() {
    
        return (
            <div style={{align:"left", textAlign: "left"}}>
                <br/>
                <Form {... layout}
                    name="basic"
                    initialValues={{
                        "report_type": this.props.intl.formatMessage({id: getDescriptionFromUrl(this.report_url)})
                    }}                   
                >
                    <Form.Item 
                        label={this.props.intl.formatMessage({id: "ReportOn"})}
                        name="report_type" 
                    >
                    <Select  style={{ width: 240 }} onChange={(e, option) => {this.onOnTypeChange(e, option)}}>
                        {this.report_types.map(item => 
                            <Select.Option key  = {item.key} value={item.description}>{item.description}</Select.Option>)
                        }
                    </Select>
                    </Form.Item>                

                    <Form.Item>
                    <PrintersSelectTable 
                        printer_id = {this.printer_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangePrinter(selectedRowKeys)}/>
                    </Form.Item>
                    <Form.Item>
                    <UsersSelectTable 
                        user_id = {this.user_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangeUser(selectedRowKeys)}/>
                    </Form.Item>
                    <Form.Item>
                    <UserGroupsSelectTable 
                        group_id = {this.group_id}
                        onSelectChange = {(selectedRowKeys) => this.onSelectChangeUserGroup(selectedRowKeys)}/>
                    </Form.Item>
                </Form>
                <ReportDescription description={this.report_description}/>
            </div>
        );
      }
}

export default (injectIntl(CommonReportStep2, {
    withRef: true,
  }));